import { GptVersion } from '@common-types/chat'
import { Module } from './types'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const module: Module = {
  state: () => ({
    client: null,
    clientBot: null,
    loginToken: null,
    hasSubscriptions: false,
    initPromotionalId: null,
    gptVersion: GptVersion.GPT_3,
  }),
  getters,
  mutations,
  actions,
  namespaced: true,
}

export default module
